export class DeviceViewportDetection {

    /**
     * Get viewport width.
     */
    public get width() {
        return window.innerWidth;
    }

    /**
     * Get viewport height.
     */
    public get height() {
        return window.innerHeight;
    }

    /**
     * Get screen height.
     */
    public get screenHeight() {
        return window.screen.height;
    }

    /**
     * Get screen width.
     */
    public get screenWidth() {
        return window.screen.width;
    }

    /**
     * Get viewport width minus the safeAreaInsets
     */
    public get safeAreaWidth() {
        return this.width - this.safeAreaInsetRight - this.safeAreaInsetLeft;
    }

    /**
     * Get viewport height minus the safeAreaInsets
     */
    public get safeAreaHeight() {
        return this.width - this.safeAreaInsetRight - this.safeAreaInsetLeft;
    }

    // https://benfrain.com/how-to-get-the-value-of-phone-notches-environment-variables-env-in-javascript-from-css/
    // https://stackoverflow.com/questions/47112393/getting-the-iphone-x-safe-area-using-javascript
    public get safeAreaInsetTop() {
        const sait = window.getComputedStyle(document.documentElement).getPropertyValue("--safeAreaInsetTop");
        return parseInt(sait.replace("px", ""));
    }
    public get safeAreaInsetRight() {
        const sair = window.getComputedStyle(document.documentElement).getPropertyValue("--safeAreaInsetRight");
        return parseInt(sair.replace("px", ""));
    }
    public get safeAreaInsetBottom() {
        const saib = window.getComputedStyle(document.documentElement).getPropertyValue("--safeAreaInsetBottom");
        return parseInt(saib.replace("px", ""));
    }
    public get safeAreaInsetLeft() {
        const sail = window.getComputedStyle(document.documentElement).getPropertyValue("--safeAreaInsetLeft");
        return parseInt(sail.replace("px", ""));
    }

    /**
     * Get the pixel ratio for the current running device.
     */
    public get pixelRatio() {
        var ratio = 1;

        const screen = window.screen as any;

        // To account for zoom, change to use deviceXDPI instead of systemXDPI
        if (screen.systemXDPI !== undefined && screen.logicalXDPI !== undefined && screen.systemXDPI > screen.logicalXDPI) {
            // Only allow for values > 1
            ratio = screen.systemXDPI / screen.logicalXDPI;
        } else if (window.devicePixelRatio !== undefined) {
            ratio = window.devicePixelRatio;
        }
        return ratio;
    }

    public get isPortrait() {
        return window.matchMedia("(orientation: portrait)").matches;
    }
}